import React from 'react';
import classes from './PaginationNavButton.module.css';

const PaginationNavButton = ({ disabled, onClick, text }) => (
  <button type="button" className={classes.navBtn} disabled={disabled} onClick={onClick} >
    <span className={classes.navBtnText}>{text}</span>
  </button>
);

export default PaginationNavButton;
